import { FC, useState } from 'react'
import { ReactComponent as GuardIcon } from '@/assets/icons/guard.svg'
import { Button, Input, Form } from 'antd'
import styles from './index.module.scss'
import i18n from '@/services/i18n'
import Modal from '../Modal'
import { useSendEmail } from '@/hooks/user'
import { BusinessType } from '@/constants/enum'
import { genVerificationCode, validate } from '@/utils/validator'

const { t } = i18n

const verificationCodeRule = genVerificationCode()

interface EmailModalContentProps {
  email: string
  businessType: BusinessType
  onChange: (code: string, businessId: string) => string
}

const EmailModalContent: FC<EmailModalContentProps> = ({ email, onChange, businessType }) => {
  const { resend, countDown, businessId } = useSendEmail(email, businessType)
  const [errMsg, setErrMsg] = useState('')
  const handleChange = (evt: any) => {
    const err = onChange(evt.target.value, businessId)
    setErrMsg(err)
  }
  return (
    <Form.Item validateStatus={errMsg && 'error'} help={errMsg} className={styles.formItem}>
      <Input
        onChange={handleChange}
        className={styles.emailModalContent}
        placeholder={t('emailAuthenticator.placeholder') || ''}
        type="email"
        suffix={
          countDown > 0 ? (
            `${countDown}${t('common.second')}`
          ) : (
            <Button type="link" onClick={resend}>
              {t('emailAuthenticator.retry')}
            </Button>
          )
        }
      />
    </Form.Item>
  )
}

const open = (
  email: string,
  businessType: BusinessType,
  callback: (data: string, businessId: string) => void
) => {
  let code = ''
  let businessId = ''
  const modal = Modal.confirm({
    title: (
      <div className={styles.title}>
        {t('emailAuthenticator.title')}
        <span className={styles.subTitle}>{t('emailAuthenticator.subTitle', { email })}</span>
      </div>
    ),
    content: (
      <EmailModalContent
        onChange={(emailCode, bid) => {
          const { isValid, errMsg } = validate(emailCode, [verificationCodeRule])
          code = emailCode
          businessId = bid
          modal.update({
            okButtonProps: {
              disabled: !isValid,
            },
          })
          return errMsg
        }}
        email={email}
        businessType={businessType}
      />
    ),
    okButtonProps: { disabled: !code },
    icon: <GuardIcon />,
    closable: true,
    onCancel: () => {
      callback('', '')
    },
    onOk: () => {
      callback(code, businessId)
    },
  })
}

export default {
  open,
}
